// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"364":"3c95aa2c","750":"f01a5412"}[chunkId] + ".js";
};